type BadgeTone = 'success' | 'warning' | 'critical' | 'info' | 'neutral';

const toneClasses: Record<BadgeTone, string> = {
  success: 'bg-brand-light text-brand-700',
  warning: 'bg-amber-50 text-amber-700',
  critical: 'bg-red-50 text-critical',
  info: 'bg-blue-50 text-info',
  neutral: 'bg-ink-100 text-ink-600',
};

export function Badge({ children, tone = 'neutral' }: { children: React.ReactNode; tone?: BadgeTone }) {
  return (
    <span className={['inline-flex items-center rounded-full px-2.5 py-1 text-xs font-semibold', toneClasses[tone]].join(' ')}>
      {children}
    </span>
  );
}
